// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PeoplesUploadedSvg from '@rsuite/icon-font/lib/people/PeoplesUploaded';
var PeoplesUploaded = createSvgIcon({
  as: PeoplesUploadedSvg,
  ariaLabel: 'peoples uploaded',
  category: 'people',
  displayName: 'PeoplesUploaded'
});
export default PeoplesUploaded;